import type { FeathersList } from '../types'
import { store } from '../store'
import apiClient from './apiClient'

type Country = { _id: string; name: string; cities?: string[] }

export const countryApi = apiClient.injectEndpoints({
  endpoints: (builder) => ({
    getCountries: builder.query<FeathersList<Country>, void>({
      query: () => ({ url: '/countries?$limit=1000', method: 'GET' }),
    }),
    getCountryCities: builder.query<string[], string>({
      query: (countryId) => ({
        url: `/countries?_id=${countryId}&$limit=1&withCities=1`,
        method: 'GET',
      }),
      transformResponse: (res: FeathersList<Country> | Country[]) => {
        const country = Array.isArray(res) ? res[0] : res?.data?.[0]
        return (country?.cities ?? []) as string[]
      },
    }),
  }),
  overrideExisting: true,
})

export const { useGetCountriesQuery, useGetCountryCitiesQuery } = countryApi

export const notificationApi = apiClient.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<FeathersList<Record<string, unknown>>, void>({
      query: () => {
        const userId = store.getState()?.auth?.user?._id ?? null
        return {
          url: `/notifications?$limit=1000&userId=${userId}`,
          method: 'GET',
        }
      },
      providesTags: ['Notification'],
    }),
  }),
  overrideExisting: true,
})

export const { useGetNotificationsQuery } = notificationApi
